<script>
    /**
     * @typedef {Object} Props
     * @property {boolean} [isOpen] - If tooltip should be visbile
     * @property {boolean} [noArrow] - If arrow poiting to alignment should be shown
     * @property {string} [alignment] - Can be 'top', 'bottom', 'right'
     * @property {import('svelte').Snippet} [children]
     */

    /** @type {Props} */
    let {
        isOpen = $bindable(false),
        canBeClosed = true,
        noArrow = false,
        alignment = 'bottom',
        children,
    } = $props()

    let selfElement = $state()

    function onClickDocument(event) {
        if (canBeClosed) {
            if (!isOpen) {
                return
            }
            if (selfElement.contains(event.target)) {
                return
            }
            isOpen = false
        }
    }
</script>

<svelte:document onclick={onClickDocument} />

{#if isOpen}
    <div
        class="tooltip"
        bind:this={selfElement}
        class:no-arrow={noArrow}
        class:alignment-top={alignment === 'top'}
        class:alignment-bottom={alignment === 'bottom'}
        class:alignment-right={alignment === 'right'}
    >
        <div class="content">
            <div>
                {@render children?.()}
            </div>
        </div>
    </div>
{/if}

<style lang="scss">/*
* Scut, a collection of Sass utilities
* to ease and improve our implementations of common style-code patterns.
* v1.0.1
* Docs at http://davidtheclark.github.io/scut
*/
/* TODO implement tooltip arrow */
.tooltip {
  box-shadow: 0 10px 30px 0 rgba(18, 45, 64, 0.12);
  border-radius: 16px;
  font-size: 14px;
  z-index: 9200;
  position: absolute;
  left: 50%;
  display: block;
  width: max-content;
  background: #fff;
  color: #122d40;
  user-select: none;
  cursor: default;
  border: 1px solid hsl(40, 4%, 84%);
}
.tooltip:not(.tooltip.no-arrow):after {
  content: "";
  position: absolute;
  left: 50%;
  height: 10px;
  width: 10px;
  transform: translateX(-50%) translateY(-50%) rotate(45deg);
  background: inherit;
  border-top: 1px solid hsl(40, 4%, 84%);
  border-left: 1px solid hsl(40, 4%, 84%);
}
.tooltip.alignment-top {
  top: 0;
  transform: translateX(-50%) translateY(-100%) translateY(-10px);
}
.tooltip.alignment-bottom {
  top: 100%;
  transform: translateX(-50%) translateY(10px);
}
.tooltip.alignment-bottom:after {
  top: 0;
}
.tooltip.alignment-right {
  left: 100%;
  top: 50%;
  transform: translateX(10px) translateY(-50%);
}
.tooltip.alignment-right:not(.tooltip.alignment-right.no-arrow):after {
  left: 0;
  top: 50%;
  border-top: none;
  border-bottom: 1px solid hsl(40, 4%, 84%);
}

.content {
  padding: 8px 16px;
  display: grid;
  grid-template-rows: min-content min-content;
  grid-template-columns: 1fr;
}
.content > :global(div:empty) {
  display: none;
}
.content :global(svg),
.content :global(img) {
  max-height: 16px;
  max-width: 16px;
}</style>
